const INACTIVE_REGISTRATION_STATUSES = new Set([
  "cancelled",
  "canceled",
  "rejected",
  "declined",
  "removed",
  "deleted",
  "expired",
  "refunded",
]);

function isActive(record) {
  if (!record || typeof record !== "object") return false;
  return !INACTIVE_REGISTRATION_STATUSES.has(
    String(record.status || record.state || "").trim().toLowerCase()
  );
}

function hasTransfer(record) {
  return (
    record?.transfer?.enabled === true ||
    record?.transferSelected === true ||
    record?.includeTransfer === true ||
    record?.transfer === true
  );
}

export function countReservedTransferSeats(registrations) {
  return Object.values(registrations || {}).reduce((total, registration) => {
    if (!isActive(registration)) return total;

    let reserved = hasTransfer(registration) ? 1 : 0;
    const invitees =
      registration.invitees && typeof registration.invitees === "object"
        ? Object.values(registration.invitees)
        : [];

    invitees.forEach((invitee) => {
      if (isActive(invitee) && hasTransfer(invitee)) reserved += 1;
    });

    return total + reserved;
  }, 0);
}
